import { Component } from '@angular/core';
import { DynamicOptionsComponent } from '../dynamic-options';
import { of } from 'rxjs';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'automata-order-form-enabled-options',
  template: ``,
  standalone: true,
})
export class BoolListOptionsComponent implements DynamicOptionsComponent {
  initialValue = true;
  selectedValue$ = of(true);

  getSelectedValue(): boolean {
    return true;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  isFormValid(): boolean {
    return true;
  }
}
